module.exports = __webpack_public_path__ + "img/error_varios_icon.89bad607.svg";